import React from "react";
import CryptoTracker from "../components/CryptoTracker";

const Homepage = () => {
  return (
    <div>
      <CryptoTracker />
    </div>
  );
};

export default Homepage;
